import React from 'react';
import getConfig from 'next/config';

import Link from '~/src/components/link/Link';

import {getCategoryUrl} from '~/src/utilities/helpers/link';
import initPolyglot from '~/src/utilities/libs/polyglot';

import css from './NoContent.module.scss';

import i18nStrings from './NoContent.i18n.json';

const getTranslation = initPolyglot(i18nStrings);

const {publicRuntimeConfig: config} = getConfig();

const NoContent = () => {
    return (
        <div className={css.noContentWarpper}>
            <div className={css.noContent}>
                <h1 className={css.noContentTitle}>{getTranslation('noContentTitle')}</h1>
                <p className={css.noContentText}>{getTranslation('noContentText')}</p>
                <Link href={getCategoryUrl(config.frontCategory)} className={css.noContentButton}>
                    {getTranslation('noContentLinkText')}
                </Link>
            </div>
        </div>
    );
};

export default NoContent;
